import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AiChatService } from './services/ai-chat.service';
import { AiCommandBarComponent } from './components/ai-command-bar/ai-command-bar.component';
import { AiChatboxComponent } from './components/ai-chatbox/ai-chatbox.component';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { AiContainerComponent } from './components/ai-container/ai-container.component';
import { AiHumanInLoopComponent } from './components/ai-human-in-loop/ai-human-in-loop.component';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  imports: [CdkDrag, CommonModule, FormsModule, MarkdownModule.forRoot()],
  declarations: [AiHumanInLoopComponent, AiContainerComponent, AiCommandBarComponent, AiChatboxComponent],
  exports: [AiHumanInLoopComponent, AiContainerComponent, AiCommandBarComponent, AiChatboxComponent],
  providers: [],
})
export class AiModule {
  static forRoot() {
    return {
      ngModule: AiModule,
      providers: [AiChatService],
    };
  }
  static forServices() {
    return [AiChatService];
  }
}
